"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Waiting;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Backdrop = _interopRequireDefault(require("@material-ui/core/Backdrop"));
var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function Waiting(_ref) {
  var _ref$fullscreen = _ref.fullscreen,
    fullscreen = _ref$fullscreen === void 0 ? true : _ref$fullscreen,
    isLoading = _ref.isLoading,
    message = _ref.message;
  return /*#__PURE__*/_react.default.createElement(SizedBackdrop, {
    open: isLoading,
    fullscreen: fullscreen
  }, /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
    color: "inherit"
  }), /*#__PURE__*/_react.default.createElement(WaitingText, null, message));
}
var WaitingText = _styledComponents.default.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-left: 12px;\n  font-size: ", ";\n  font-weight: ", ";\n"])), function (props) {
  return props.theme.font.megaSize;
}, function (props) {
  return props.theme.font.boldWeight;
});
var SizedBackdrop = (0, _styledComponents.default)(_Backdrop.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  && {\n    position: ", ";\n  }\n"])), function (props) {
  return props.fullscreen ? 'fixed' : 'absolute';
});
Waiting.defaultProps = {
  fullscreen: true
};
Waiting.propTypes = {
  fullscreen: _propTypes.default.bool,
  isLoading: _propTypes.default.bool.isRequired,
  message: _propTypes.default.string.isRequired
};